import React from 'react';
import * as types from '#constants/types';

interface Auth {
    isAuthenticated?: boolean;
    setUserDetail?: (isAuthenticated: boolean, userDetail?: types.UserDetail) => void;
    logout?: () => void;
}

export default React.createContext<Auth>({});
